"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDetailedPerformanceHeaderForTeacher = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledDetailedPerformanceHeaderForTeacher = styled_components_1.default.thead(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  th {\n    background-color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: normal;\n    max-width: 200px;\n    min-width: ", ";\n    padding: ", " ", ";\n\n    &.student,\n    &.name {\n      min-width: 230px;\n    }\n\n    i {\n      cursor: pointer;\n    }\n\n    .sorting-column {\n      border: none;\n      background-color: transparent;\n    }\n\n    .padding-button {\n      padding: 1px 6px;\n    }\n\n    &.data-header > .column-header {\n      ", ";\n      text-transform: uppercase;\n\n      > div {\n        flex-direction: ", ";\n        ", ";\n        height: 48px;\n\n        > div {\n          justify-content: center;\n          margin: 0 ", ";\n          font-size: ", ";\n        }\n      }\n    }\n\n    &:not(:first-child) {\n      text-align: center;\n    }\n\n    &.arrows {\n      width: 105px;\n\n      > div {\n        display: flex;\n        justify-content: space-between;\n      }\n    }\n  }\n"], ["\n  th {\n    background-color: ", ";\n    color: ", ";\n    font-size: ", ";\n    font-weight: normal;\n    max-width: 200px;\n    min-width: ", ";\n    padding: ", " ", ";\n\n    &.student,\n    &.name {\n      min-width: 230px;\n    }\n\n    i {\n      cursor: pointer;\n    }\n\n    .sorting-column {\n      border: none;\n      background-color: transparent;\n    }\n\n    .padding-button {\n      padding: 1px 6px;\n    }\n\n    &.data-header > .column-header {\n      ", ";\n      text-transform: uppercase;\n\n      > div {\n        flex-direction: ", ";\n        ", ";\n        height: 48px;\n\n        > div {\n          justify-content: center;\n          margin: 0 ", ";\n          font-size: ", ";\n        }\n      }\n    }\n\n    &:not(:first-child) {\n      text-align: center;\n    }\n\n    &.arrows {\n      width: 105px;\n\n      > div {\n        display: flex;\n        justify-content: space-between;\n      }\n    }\n  }\n"])), function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.dark;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var isDiagnostic = _a.isDiagnostic;
    return (isDiagnostic ? '186px' : '200px');
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x2;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x3;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var isDiagnostic = _a.isDiagnostic;
    return (isDiagnostic ? 'row' : 'column');
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var Spacing = _a.theme.Spacing, isDiagnostic = _a.isDiagnostic;
    return (isDiagnostic ? Spacing.x2 : 0);
}, function (_a) {
    var Typography = _a.theme.Typography, isDiagnostic = _a.isDiagnostic;
    return isDiagnostic ? Typography.Sizes.md : Typography.Sizes.smd;
});
var templateObject_1;
